import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SessionMonitorService {
  
  private session = new Subject<boolean>();
 
  constructor() { }

  public setSessionActive = (active: boolean): void => {
    this.session.next(active);
  }

  public sessionMonitor = () =>
    this.session.asObservable();
 
}
